import { render, staticRenderFns } from "./CanvasEditorHistory.vue?vue&type=template&id=0f6ee16c&scoped=true&"
import script from "./CanvasEditorHistory.vue?vue&type=script&lang=js&"
export * from "./CanvasEditorHistory.vue?vue&type=script&lang=js&"
import style0 from "./CanvasEditorHistory.vue?vue&type=style&index=0&id=0f6ee16c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6ee16c",
  null
  
)

export default component.exports